import React from 'react'
import { observer } from 'mobx-react'
import { Table as ChakraTable, TableContainer } from '@chakra-ui/react'
import TableHeader from './TableHeader'
import TableBody from './TableBody'

export interface TableProps {
  options: {
    xAxis: {
      categories: string[]
    }
    series: {
      name: string
      data: any[]
    }[]
  }
  [key: string]: any
}

const Table = ({ options, ...rest }: TableProps) => {
  return (
    <TableContainer maxHeight="30rem" overflowY="auto" className="custom-scrollbar">
      <ChakraTable {...rest}>
        <TableHeader columns={options.xAxis.categories} />
        <TableBody data={options.series} />
      </ChakraTable>
    </TableContainer>
  )
}

export default observer(Table)
